import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import colors from '@/styles/color.scss';
let FaceSelection = class FaceSelection extends Vue {
    visible = true;
    featureList = [];
    scale = 1;
    maxScale = 4;
    minScale = 0.5;
    choseIndex = 0;
    resourceImg = '';
    get conputeStyle() {
        const scale = this.scale;
        return {
            transform: `scale(${scale})`,
        };
    }
    plus() {
        if (this.maxScale <= this.scale) {
            return (this.scale = this.maxScale);
        }
        this.scale += 0.1;
    }
    minus() {
        if (this.minScale >= this.scale) {
            return (this.scale = this.minScale);
        }
        this.scale -= 0.1;
    }
    getCanvasImageData(imgData, w, h) {
        const cv = document.createElement('canvas');
        const cv1 = cv?.getContext('2d');
        cv.width = w;
        cv.height = h;
        cv1?.putImageData(imgData, 0, 0, 0, 0, w, h);
        const base64Url = cv.toDataURL();
        cv.remove();
        return base64Url;
    }
    handleImgChange(index) {
        this.choseIndex = index;
    }
    onCallback() {
        return this.featureList?.[this.choseIndex] || '';
    }
    mounted() {
        this.$nextTick(() => {
            const canvas = this.$refs.mycanvas;
            if (!canvas)
                return;
            const context = canvas.getContext('2d');
            const img = new Image();
            img.onload = () => {
                if (img.complete) {
                    const { height, width } = img;
                    canvas?.setAttribute('width', String(width));
                    canvas?.setAttribute('height', String(height));
                    context?.drawImage(img, 0, 0, width, height);
                    context.strokeStyle = colors.white;
                    this.featureList = this.featureList?.map((item) => {
                        if (item) {
                            const cv = this.$refs.matting;
                            const cv1 = cv?.getContext('2d');
                            let imageData = {};
                            const verticesData = item.boundingPoly.vertices;
                            const x = verticesData[0].x;
                            const y = verticesData[0].y;
                            const rightX = verticesData[1].x - x;
                            const rightY = verticesData[1].y - y;
                            const startX = x * width;
                            const startY = y * height;
                            const endX = Math.abs(rightX * width);
                            const endY = Math.abs(rightY * height);
                            context?.strokeRect(startX, startY, endX, endY); // 绘制矩形 X y 长 宽
                            imageData = context?.getImageData(startX, startY, endX, endY);
                            cv1?.putImageData(imageData, 0, 0);
                            const base64Img = this.getCanvasImageData(imageData, endX, endY);
                            item.base64Img = base64Img;
                            return item;
                        }
                    });
                }
            };
            img.src = this.resourceImg;
            img.crossOrigin = '';
        });
    }
};
FaceSelection = __decorate([
    Component({
        name: 'faceSelection'
    })
], FaceSelection);
export default FaceSelection;
